/* eslint-disable */
import * as d  from '@/librerias/decimal.js-light-master/decimal.min.js'
export function revisar_numero(num)
{
    //return isNaN(num) ? 0 : num==="" ? 0 : parseFloat(num);
    return isNaN(num) ? 0 : num==="" ? 0 : num===null ? 0 : num===true ?  0 : num===false ?  0 : num===Infinity ?  0 : num===-Infinity ?  0 :  parseFloat(num);
}

export function calcular_potencia(datos)
{
    let dt={
        base:datos[0],
        elevar:revisar_numero(datos[1]),
        con:1,
        resultado:datos[0]
    }
    while(dt.con<dt.elevar)
    {
        dt.resultado=calcular_multiplicacion([dt.resultado,dt.base]);
        dt.con++;
    }
    return dt.resultado;

}

export function calcular_promedio(datos)
{
    let dt={
        suma:0,
        divicion:0
    };
    dt.suma=sumar_dec(datos);
    dt.divicion=calcular_divicion([dt.suma,datos.length]);
    return dt.divicion;
}


export function calcular_divicion(datos)
{
    let dt={
        num:0,
        resultado:0
    };
    datos.forEach((numero,index)=>{

        numero=revisar_numero(numero);
        if(index==0)
        {
            dt.resultado=numero;
        }
        else
        {
            if(numero!=0)
            {
                dt.num=new d.Decimal( dt.resultado );
                dt.resultado=dt.num.dividedBy( numero ).toNumber();
            }
        }
    });

    return dt.resultado;
}

export function calcular_suma(datos)
{
    var val={
        num: 0,
        resultado:0,
    }
    datos.forEach((numero)=>{
        val.num= new d.Decimal( revisar_numero( numero ) );
        val.resultado=val.num.plus(val.resultado).toNumber();
    });
    return val.resultado;
}


export function calcular_resta(datos)
{
    let dt={
        num:0,
        resultado:0
    };
    datos.forEach((numero,index)=>{
        numero=revisar_numero(numero);
        if(index==0)
        {
            dt.resultado=numero;
        }
        else
        {        
            dt.num= new d.Decimal(  dt.resultado  );
            dt.resultado=dt.num.minus( numero ).toNumber();
        }
    });
    return dt.resultado;
}

export function calcular_multiplicacion(datos)
{
    let dt={
        num:0,
        resultado:1,
    };
    datos.forEach((numero)=>{
        dt.num= new d.Decimal( revisar_numero( numero ) );
        dt.resultado=dt.num.times(dt.resultado).toNumber();
    });
    return dt.resultado;
}

export function revisar_entrada(a)
{
    //return isNaN(num) ? 0 : num==="" ? 0 : num===null ? 0 : num===true ?  0 : num===false ?  0 : num===Infinity ?  0 : num===-Infinity ?  0 :  parseFloat(num);
    return a===null ? '' : a;
}

export function atributo(item,atributo)
{
    return item.target.getAttribute(atributo);
}

export function revisar_texto(t)
{    
    let a='';
    if(t===null)
    {
        a='';
    }
    else
    {
        let lista=[
            '<script>',
            '</script>',
            'localStorage'
        ];
        lista.forEach((item,index)=>{

           t=t.replace(item,'');

        });
        a=t;
    }
    return a;
}

/*

function calcular_desviacion_estandar(datos)
{
    var promedio=calcular_promedio(datos);
    var restas=[],con=0;
    while(con<datos.length)
    {
        var nums={
            n1:revisar_numero(datos[con]),
            resta:0
        }
        //nums.resta=nums.n1-promedio;
        nums.resta=calcular_resta([nums.n1,promedio]);
        restas.push(nums.resta);
        con++;
    }
    var potencias=[];
    restas.forEach(function(item,index){
        //potencias.push(Math.pow(item,2));
        potencias.push(calcular_potencia([item,2]));
    });
    var operaciones={
        sumas:sumar_dec(potencias),
        div:0,
        can_pot:parseFloat(potencias.length-1),
        raiz:0
    }
    //operaciones.div=operaciones.sumas/operaciones.can_pot;
    operaciones.div=calcular_divicion([operaciones.sumas,operaciones.can_pot]);
    //operaciones.raiz=parseFloat(Math.sqrt(operaciones.div));
    operaciones.raiz=Math.sqrt(operaciones.div);
    return operaciones.raiz;
}

function convertir_exponencial_a_decimal(numero)
{
    let dt={
        num:revisar_numero(numero),
        exponenciales:{
            dividido:[],
            con:0,
            final:{
                ceros:'',
                numero:'',
                final:'',
                a:0
            }
        },
        final:0
    };
    dt.num=(dt.num).toString();
    if((dt.num).includes("e"))
    {
        if((dt.num).includes("e-"))
        {
            //console.log('exponencionales------------------------>>>>>>>>>>>>');
            dt.exponenciales.dividido=(dt.num).split("e-");
            dt.exponenciales.dividido[1]=parseFloat(dt.exponenciales.dividido[1]);

            dt.exponenciales.dividido[0]=Array.from(dt.exponenciales.dividido[0]);
            //console.log(dt.exponenciales.dividido[0]);
            if(dt.exponenciales.dividido[0][0]=='-')
            {
                dt.exponenciales.final.ceros=`-0.`;
                dt.exponenciales.dividido[0].splice(0,1);
            }
            else
            {
                dt.exponenciales.final.ceros='0.'
            }
            if(dt.exponenciales.dividido[0].indexOf('.')!=-1)
            {
                dt.exponenciales.dividido[0].splice(dt.exponenciales.dividido[0].indexOf('.'),1);
            }
            dt.exponenciales.final.numero=dt.exponenciales.dividido[0].join('');
            while(dt.exponenciales.con<dt.exponenciales.dividido[1]-1)
            {
                dt.exponenciales.final.ceros+='0';
                dt.exponenciales.con++; 
            }
            dt.exponenciales.final.final=`${dt.exponenciales.final.ceros}${dt.exponenciales.final.numero}`;
            
            //console.log(dt.exponenciales);
            //dt.final=calcular_decimales_especificos_sin_redondear_ni_rellenar(dt.exponenciales.final.final,dt.separado[1].length);
            dt.final=dt.exponenciales.final.final;
        }
        else
        {
            dt.final=dt.num;
        }
    }
    else
    {
        dt.final=dt.num;
    }
    return dt.final;
}
function mayor_cantidad_decimales(numeros)
{
    let dt={
        nums:numeros,
        decimales:{
            mayor:0,
            num_text:'',
            separado:''
        }
    };
    dt.nums.forEach((item)=>{
        //console.log('numero');
        //console.log(item);
        item=revisar_numero(item);
        if(Number.isInteger(item)==false)
        {
            item=convertir_exponencial_a_decimal(item);
            dt.decimales.num_text=item.toString();
            dt.decimales.separado=dt.decimales.num_text.split('.');     
            //console.log('separado es');
            //console.log(dt.decimales.separado);       
            if(dt.decimales.mayor<dt.decimales.separado[1].length)
            {
                dt.decimales.mayor=dt.decimales.separado[1].length;
            }
        }
    });
    return dt.decimales.mayor;
}
function redondear_decimales(num,decimales)
{
    let dt={
        num:revisar_numero(num),
        decimales:decimales,
        final:num,
    
        num_convertido:{
            decimal:'',
            separado:'',
            //conta:0,
            numero_valido:0,
            contador_ceros_antes_numero_valido:0
        }
    };
    if(Number.isInteger(dt.num)==false && dt.decimales>0)
    {

        dt.num_convertido.decimal=convertir_exponencial_a_decimal(dt.num);
        dt.num_convertido.decimal=dt.num_convertido.decimal.toString();
        dt.num_convertido.separado=dt.num_convertido.decimal.split('.');

        if(revisar_numero( dt.num_convertido.separado[1][0] ) === 0 )
        {
            if( dt.decimales>=dt.num_convertido.separado[1].length)
            {
                dt.final=dt.num.toFixed(dt.decimales);
                dt.final=revisar_numero(dt.final);
                
            }
            else
            {

                for(let value of dt.num_convertido.separado[1])
                {
                    //dt.num_convertido.numero_valido++;
                    if(revisar_numero(value)!=0)
                    {
                        break;
                    }
                    dt.num_convertido.contador_ceros_antes_numero_valido++
                }


                if(dt.decimales<=dt.num_convertido.contador_ceros_antes_numero_valido)
                {

                    for(let value of dt.num_convertido.separado[1])
                    {
                        dt.num_convertido.numero_valido++;
                        if(revisar_numero(value)!=0)
                        {
                            break;
                        }
                    }

                    dt.final=dt.num.toFixed(dt.num_convertido.numero_valido);
                    dt.final=revisar_numero(dt.final);
                }
                else
                {
                    dt.final=dt.num.toFixed(dt.decimales);
                    dt.final=revisar_numero(dt.final);
                }
            }


        }
        else
        {
        
            dt.final=dt.num.toFixed(dt.decimales);
            dt.final=revisar_numero(dt.final);
            if(Number.isInteger(dt.final))
            {
                dt.final=redondear_decimales(dt.num,dt.decimales+1);
            }
        }


    }

    return dt.final;
}

*/
